// DATA FROM VARIANT REFERENCE
const customvariantid = targetVariant.id;
const barcode = targetVariant.barcode;
const limit = targetVariant.quantity;
const targetSku = targetVariant.sku;
let productPricing = targetVariant.price / 100;

// PRICE FORMATTER
const formatter = new Intl.NumberFormat("ja-JP", {
  style: "currency",
  currency: "JPY",
});

let errorFontElement = document.createElement("p");
errorFontElement.textContent = "ERROR FONT";
errorFontElement.setAttribute("class", "cpb-category-font");

//GLOBAL VALUES
let cpbAddButton,
  cpbResetButton,
  cpbTitle,
  cpbQuantityValue,
  cpbIncreaseQuantityButton,
  cpbConditions = false,
  cpbQuantityOK = true,
  cpbFontSelector,
  productDescription = document.getElementById("productDescription"),
  cpbStep1Title,
  cpbStep1Description,
  cpbStep1Caution = document.getElementById("cpbStep1Caution"),
  cpbStep1CautionTarget,
  cpbStep1CautionTargetPosition,
  cpbAreas;

const url = new URL(window.location);
const line_key = url.searchParams.get("key");
const line_quantity = url.searchParams.get("quantity");

// START ******************* CPB FUNCTIONS

// CPB APP REACTOR
function triggerReactChangeEvent(element, value) {
  let node;
  if (element instanceof window.HTMLElement) node = element;

  let inputTypes = [
    window.HTMLInputElement,
    window.HTMLSelectElement,
    window.HTMLTextAreaElement,
  ];

  let index = inputTypes.indexOf(node.__proto__.constructor);

  if (index > -1) {
    let eventType = index == 1 ? "change" : "input";
    let setValue = Object.getOwnPropertyDescriptor(node.__proto__, "value").set;
    let event = new Event(eventType, { bubbles: true });

    setValue.call(node, value);
    node.dispatchEvent(event);
  }
}

function checkTextInput() {
  let textInput = document.querySelectorAll(
    ".cpb-option-type-input__wrapper input"
  );
  let errorCounter = 0;

  cpbAreas.forEach((area) => {
    let description = area.querySelector(".cpb-category-desc");
    let textLimit = area.querySelector("input");
    let element = description.querySelector(".cpb__area__description");

    if (!element && textLimit) {
      let moreDescription = document.createElement("p");
      moreDescription.setAttribute("class", "cpb__area__description");
      moreDescription.textContent = `※1行に${
        textLimit.maxLength - 4
      }文字まで入力いただけます。`;
      description.appendChild(moreDescription);
    }
  });

  if (textInput)
    textInput.forEach((input) => {
      let inputLimit = input.maxLength - 4;
      let parent = input.parentElement;

      let errorLimit = parent.querySelector(".cpb__area__error__invalid");
      let errorEmpty = parent.querySelector(".cpb__area__error__empty");

      if (!errorLimit) {
        const invalidTxt = document.createElement("p");
        invalidTxt.setAttribute("class", "cpb__area__error__invalid");
        invalidTxt.textContent = `印字できるのは${inputLimit}文字までです。`;
        parent.appendChild(invalidTxt);
        errorLimit = invalidTxt;
      }

      if (!errorEmpty) {
        const emptyTxt = document.createElement("p");
        emptyTxt.setAttribute("class", "cpb__area__error__empty");
        emptyTxt.textContent = `空欄のままオーダーできません。このエリアに印字が不要な場合は、行の選択を解除してから空欄にしてください。`;

        errorEmpty = emptyTxt;
        parent.appendChild(emptyTxt);
      }

      if (input.value.length == 0) {
        input.classList.add("input--error");
        errorEmpty.style.display = "block";
        errorCounter++;
      } else if (input.value.length > inputLimit) {
        input.classList.add("input--error");
        errorLimit.style.display = "block";
        errorCounter++;
      } else {
        input.classList.remove("input--error");
        errorLimit.style.display = "none";
        errorEmpty.style.display = "none";
      }
    });

  const textLine = document.querySelectorAll(
    ".cpb__area__line .option-type-text.active"
  );

  if (!textLine.length) errorCounter++;

  if (errorCounter > 0) return false;
  else return true;
}

function checkQuantityValue() {
  if (cpbQuantityValue.value >= limit) {
    cpbIncreaseQuantityButton.setAttribute("disabled", true);
  } else cpbIncreaseQuantityButton.removeAttribute("disabled");

  if (cpbQuantityValue.value > limit) cpbQuantityOK = false;
  else cpbQuantityOK = true;

  return cpbQuantityOK;
}

function checkFontExist(event) {
  const font = document.querySelector(".fontFamily .cpb-has-value");
  const fontDescription = document.querySelector(".font__missing");
  if (fontDescription)
    if (font) fontDescription.style.display = "none";
    else fontDescription.style.display = "block";

  return !!font;
}

function isZenkaku(input) {
  for (let i = 0; i < input.length; i++) {
    let code = input.charCodeAt(i);
    if (
      !(code >= 0x3040 && code <= 0x309f) &&
      !(code >= 0x30a0 && code <= 0x30ff)
    ) {
      return false;
    }
  }
  return true;
}

// END ******************* CPB FUNCTIONS

// START ******************* CPB MOUNTED
let customProductPrice = product.price / 100;
let customComparePrice = product.compare_at_price / 100;

// INITIATE MODAL
function activateModal() {
  const howtoButton = document.querySelector(
    "[data-modal='how-to-custom-product']"
  );
  const howToModal = document.getElementById(`how-to-custom-product`);

  howtoButton.addEventListener("click", function () {
    howToModal.classList.toggle("modal-container__active");
    howToModal.classList.toggle("modal-container__zindex");
  });
}

// INITIATE CUSTOM PRICING
function initCustomPricing() {
  let priceContainer = document.querySelector(".cpb-product-full-price");

  if (customComparePrice) {
    //ELEMENTS
    let customNamePricing = document.createElement("span");
    customNamePricing.setAttribute(
      "class",
      "custom-name-pricing compare-price-exist"
    );

    if (customProductPrice > 0) {
      let customSaleIcon = document.createElement("span");
      customSaleIcon.setAttribute("class", "compare-sale-icon");
      customSaleIcon.textContent = "今だけ半額！";
      customNamePricing.append(customSaleIcon);
    }

    priceContainer.append(customNamePricing);

    let comparePricingDiv = document.createElement("div");
    comparePricingDiv.setAttribute("class", "compare-pricing");
    comparePricingDiv.innerHTML += `<u id='comparePricing'>¥${customComparePrice}</u> 名入れオーダー価格`;

    priceContainer.append(comparePricingDiv);

    let customPricingContainer = document.createElement("div");
    customPricingContainer.setAttribute("class", "custom-pricing-container");

    let customPricingSpan = document.createElement("span");
    customPricingSpan.setAttribute("id", "custom-pricing");
    customPricingSpan.textContent = "+" + formatter.format(productPricing);

    customPricingContainer.append(customPricingSpan);
    customPricingContainer.innerHTML += "<p>商品価格</p>";

    priceContainer.append(customPricingContainer);

    let customNamePricingTotal = document.createElement("div");
    customNamePricingTotal.setAttribute("class", "custom-name-pricing-total");
    customNamePricingTotal.innerHTML +=
      "<div class='custom-name-pricing-total'>TOTAL<span id='custom-price-total'>" +
      formatter.format(productPricing + customProductPrice) +
      "</span></div>";

    priceContainer.append(customNamePricingTotal);
  } else {
    let customNamePricing = document.createElement("span");
    customNamePricing.setAttribute("class", "custom-name-pricing");
    customNamePricing.textContent = "名入れオーダー価格";
    priceContainer.append(customNamePricing);

    let customPricingContainer = document.createElement("div");
    customPricingContainer.setAttribute("class", "custom-pricing-container");
    customPricingContainer.innerHTML += `<span id='custom-pricing'>+ ${formatter.format(
      productPricing
    )}</span><p>商品価格</p>`;
    priceContainer.append(customPricingContainer);

    let customNamePricingTotal = document.createElement("div");
    customNamePricingTotal.setAttribute("class", "custom-name-pricing-total");
    customNamePricingTotal.innerHTML += `<div class='custom-name-pricing-total'>TOTAL<span id='custom-price-total'>${formatter.format(
      productPricing + customProductPrice
    )}</span></div>`;
    priceContainer.append(customNamePricingTotal);
  }
}

document.body.addEventListener("CPB_ON_PRODUCT_MOUNTED", function (event) {
  // UPDATE VARIABLES
  cpbAddButton = document.querySelector(".cpb-add-to-cart-button");
  cpbResetButton = document.querySelector(".cpb-reset-button > span");
  textInputArea = document.querySelectorAll(".cpb-name-line input");
  cpbQuantityValue = document.querySelector(".cpb-quantity-value");
  cpbIncreaseQuantityButton = document.querySelector(
    ".cpb-quantity-button-increase"
  );
  cpbFontSelector = document.querySelector(".cpb-option-type-select input");
  cpbAreas = document.querySelectorAll(".cpb__area__input");
  cpbTitle = document.querySelector(".cpb-panels-container");
  cpbStep1Title = document.querySelector(".cpb-panel-title");
  cpbStep1Description = document.querySelector(".cpb-panel-description");

  // SET MAX LIMIT
  cpbQuantityValue.setAttribute("max", limit);

  // REPLACE TEXT
  cpbResetButton.textContent = "オーダー内容をリセット";
  cpbAddButton.textContent = "この内容でオーダーする";

  // INITIATE CART SETTINGS
  if (line_key) {
    const quantityLabel = document.querySelector(".cpb-quantity-label");
    const quantityAction = document.querySelector(".cpb-quantity-actions");

    if (quantityLabel && quantityAction) {
      quantityLabel.style.display = "none";
      quantityAction.style.display = "none";
    }
  }

  // ENTER PRODUCT DESCRIPTION
  cpbTitle.prepend(productDescription.content);

  cpbStep1CautionTargetPosition = cpbStep1Description
    ? "beforeend"
    : "afterend";
  cpbStep1CautionTarget = cpbStep1Description
    ? cpbStep1Description
    : cpbStep1Title;
  cpbStep1CautionTarget.insertAdjacentHTML(
    cpbStep1CautionTargetPosition,
    cpbStep1Caution.innerHTML
  );

  activateModal();
  initCustomPricing();

  // QUANTITY INPUT CHANGE
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach((mutation) => {
      let targetQuantity = mutation.target.value;

      if (targetQuantity <= limit) {
        let total = targetQuantity * productPricing;
        document.getElementById("custom-pricing").textContent =
          "+" + formatter.format(total);
        document.getElementById("custom-price-total").textContent =
          formatter.format(customProductPrice * targetQuantity + total);

        if (customComparePrice)
          document.getElementById("comparePricing").textContent =
            formatter.format(customComparePrice * targetQuantity);
      }
    });

    if (cpbQuantityValue.value >= limit)
      cpbIncreaseQuantityButton.setAttribute("disabled", true);
    else cpbIncreaseQuantityButton.removeAttribute("disabled");
  });

  observer.observe(cpbQuantityValue, {
    attributes: true,
    childList: true,
    characterData: true,
    subtree: true,
  });

  // STICKY MOBILE
  window.addEventListener("scroll", function () {
    if (window.scrollY > 1 && window.innerWidth <= 640) {
      document.querySelector(".cpb-preview-container").classList.add("mobile");
    } else {
      document
        .querySelector(".cpb-preview-container")
        .classList.remove("mobile");
    }
  });

  // UPDATE QUANTITY IF QUANTITY IS FOUND IN URL
  if (line_quantity) triggerReactChangeEvent(cpbQuantityValue, line_quantity);
});
// END ******************* CPB MOUNTED

// START ******************* CPB UPDATED

/**
 *
 * Disable the add button if
 * Check the text input field for error such as over the limit
 * Quantity is greater or no inventory at all
 * Font doesnt exist
 *
 */
document.body.addEventListener("CPB_ON_OPTIONS_UPDATE", (event) => {
  if (!cpbAddButton) return;

  setTimeout(() => {
    console.log(
      checkTextInput() +
        " && " +
        checkQuantityValue() +
        " && " +
        checkFontExist()
    );
    if (checkTextInput() && checkQuantityValue() && checkFontExist())
      cpbAddButton.removeAttribute("disabled");
    else cpbAddButton.setAttribute("disabled", "");
  }, 10);
});

// END ********************* CPB UPDATED

// START ******************* CPB BEFORE ADD TO CART

/**
 * CLEAN CPB PRODUCT PROPERTIES
 *
 * Filters the and remove properties that are not needed and changing them
 *
 */
document.body.addEventListener("before-add-to-cart", ({ detail }) => {
  console.clear();
  const cpbProperties = detail;

  delete cpbProperties.properties.SKU;
  cpbProperties.properties._CustomTarget = targetSku;

  for (const key of Object.keys(cpbProperties.properties)) {
    const value = cpbProperties.properties[key];

    if (key.includes("文字エリア") && key.includes("_")) {
      let area = key.slice(5, 6);
      let row = key.slice(11, 12);
      cpbProperties.properties[`文字エリア${area}「${row}行目」`] = value;
      delete cpbProperties.properties[key];
    }
  }

  // UPDATES PROPERTIES
  CPB.changeCartData(cpbProperties);
});

// END ******************* CPB BEFORE ADD TO CART

// START ******************* CPB ADD TO CART

// Only triggered when product is added from the cart page
function customOnlyAddToCart() {
  fetch("/cart/change", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: line_key,
      quantity: line_quantity,
      properties: {
        _custom: "custom",
        _barcode: barcode,
      },
    }),
  })
    .then((response) => {
      console.log("Change regular product");
      window.location.href = "/cart";
    })
    .catch((error) => {
      console.error("ERROR:", error);
    });
}
// Add product to Cart
function addCustomRegular() {
  fetch("/cart/add", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: customvariantid,
      quantity: cpbQuantityValue.value,
      properties: {
        _custom: "custom",
        _barcode: barcode,
      },
    }),
  })
    .then((response) => {
      console.log("custom regular product added");
      window.location.href = "/cart";
    })
    .catch((error) => {
      console.error("ERROR:", error);
    });
}
// Add product to Cart with Campaign present
function addCustomCampaign() {
  // 本番のステッカー
  const presentVariantId = 51434421682494;

  // BPのステッカー
  // const presentVariantId = 45293991493783;

  fetch("/cart/add", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: customvariantid,
      quantity: cpbQuantityValue.value,
      properties: {
        _custom: "custom",
        _barcode: barcode,
      },
    }),
  })
    .then((response) => {
      console.log("custom regular product added");
      return fetch("/cart/add", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: presentVariantId,
          quantity: 1,
        }),
      });
    })
    .then((response) => {
      console.log("custom campaign product added");
      window.location.href = "/cart";
    })
    .catch((error) => {
      console.error("ERROR:", error);
    });
}

document.addEventListener("cpb-add-to-cart", () => {
  const targetSkuList = [
    "F5K5000",
    "F5K5001",
    "F5K5001-WB",
    "F5K4000",
    "F5K4000-WB",
    "F5K4000-WR",
    "F5K4000-WG",
    "F5K4000-O",
    "F5K3000",
    "F5K3000-WB",
    "F5K3000-WR",
    "F4K5000",
    "F4K4000",
    "F4K4000-WB",
    "F4K4000-WR",
    "F4K4000-WG",
    "F4K4000-O",
    "F4K3000",
    "F4K3000-WB",
    "F4K3000-WR",
    "F9K4000",
    "F9K3000-BR",
    "F9K3000-RK",
    "F3K9200-YB",
    "F3K9200-YR",
    "F3K9200-YO",
    "F5K9100",
    "F5K9200",
    "F5K9300",
  ];
  const isPelada = targetSkuList.includes(targetVariant.sku);

  if (line_key) customOnlyAddToCart();
  else if (isPelada) addCustomCampaign();
  else addCustomRegular();
});

// END ******************* CPB ADD TO CART

// START ******************* CPB TESTING SCRIPTS * ADDITIONAL SCRIPTS * Fix from other CPB bugs

/**
 * Check all input are valid
 * Checks whether the input is valid and within the maxlength
 * @returns boolean
 */
/*
function checkTextInput(){
    let isValid = true
    let areaInvalid = 0
    let areaEmpty = 0

    cpbAreas.forEach(area => {
        const textAreas = area.querySelectorAll('.cpb-option-type-input__wrapper input')
        const errorEmpty = area.querySelector('.cpb__area__error__empty')
        const errorInvalid = area.querySelector('.cpb__area__error__invalid')

        let textEmpty = false;
        let textInvalid = false;

        textAreas.forEach(input=> {    
            if(input.value.length <= 0 ) {
                textEmpty = true;
            }
            if(input.value.length > (input.maxLength - 4)) {
                textInvalid = true
            }
        })

        if(textInvalid) {
            areaInvalid++
            errorInvalid.style.display = 'block'
        }
        else 
            errorInvalid.style.display = 'none'

        if(textEmpty) 
            errorEmpty.style.display = 'block'
        else {
            areaEmpty++
            errorEmpty.style.display = 'none'
        }
    })

    if(areaEmpty == 0)
        isValid = false
    if(areaInvalid > 0) 
        isValid = false


	if(isValid) {
		const errorEmpty = document.querySelectorAll('.cpb__area__error__empty')
		if(errorEmpty)
		errorEmpty.forEach(error => error.style.display = 'none')
	}

    return isValid;  
}
*/
// CHECK IF TEXT ARE EMPTY
/*
	if(checkTextInput() && checkIfInputLimitIsOk() &&  cpbQuantityValue.value <= limit )
		cpbAddButton.removeAttribute('disabled')
	else
		cpbAddButton.setAttribute('disabled','')
	*/

// STCIKY FIX
/*
	window.addEventListener("scroll", function() {
		if (window.pageYOffset > 1 && window.innerWidth <= 640) {
		  document.querySelector('.cpb-preview-container').classList.add('mobile');
		} else {
		  document.querySelector('.cpb-preview-container').classList.remove('mobile');
		}
	});


    	// APPEND FONT ERROR
	let cpbFontContainer = document.querySelector('.cpb-category-fontFamily')
	cpbFontContainer.append(errorFontElement)
	*/

/*
document.addEventListener('cpb-add-to-cart', function(event) {
	
	let addQuantity = cpbQuantityValue.value

	// SET CUSTOM REGULAR DATA
	let addData = { 
		'id': customvariantid ,
		'quantity': addQuantity,
		'properties':{
			'_custom': 'custom',
			'_barcode': barcode,
		}
	}

	addProductToCart(addData)

	setTimeout(()=> {
		console.log('adding')
	},500 )

})
*/

/*
	// STCIKY FIX
	$(window).on("scroll", function() {
		if ($(window).scrollTop() > 1 && $(window).width() <= 640) {
			$('.cpb-preview-container').addClass('mobile')
		} else {
			$('.cpb-preview-container').removeClass('mobile')
		}
	});
*/

// ｷﾞガAB文
/*
function hankana2Zenkana(str) {
    var kanaMap = {
        'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
        'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
        'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
        'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
        'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
        'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
        'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
        'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
        'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
        'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
        'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
        'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
        'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
        'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
        'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
        'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
        'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
        'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
        '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
    };
    var reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
    return str
            .replace(reg, function (match) {
                return kanaMap[match];
            })
            .replace(/ﾞ/g, '゛')
            .replace(/ﾟ/g, '゜');
};
function zenkaku2Hankaku(str) {
    return str.replace(/[A-Za-z0-9]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
    });
}
function letterZenkaku(category) {
	let input = category.querySelector('input')
	let text = input.value
	text = zenkaku2Hankaku(text)
	text = hankana2Zenkana(text)
	triggerReactChangeEvent(input, text)
}
*/
/*
	if(textInputArea)
	textInputArea.forEach(input => {
		let errorTextElement = document.createElement('p')
		errorTextElement.setAttribute('class','cpb-category-error')
		errorTextElement.textContent = `印字できるのは${input.maxLength - 4}文字までです。`

		input.parentElement.parentElement.append(errorTextElement)

		errorTextElement = document.createElement('p')
		errorTextElement.setAttribute('class','cpb-category-hankaku')
		input.parentElement.parentElement.append(errorTextElement)
	})
	*/
// END ******************* CPB TESTING
